// ⚠️ AUTO-GENERATED FROM CORE REPO
// DO NOT EDIT — changes will be overwritten

(() => {
  if (window.goatHomepageHeroVideoInitialized) return;
  window.goatHomepageHeroVideoInitialized = true;

  const initialize = (section) => {
    const video = section?.querySelector('.homepage-hero__video');
    const controls = section?.querySelector('[data-homepage-hero-video-controls]');
    if (!video || !controls || controls.dataset.initialized) return;
    controls.dataset.initialized = 'true';

    const button = controls.querySelector('[data-homepage-hero-video-toggle]');
    const unmuteIcon = button.querySelector('[data-homepage-hero-unmute-icon]');
    const muteIcon = button.querySelector('[data-homepage-hero-mute-icon]');

    const updateControls = () => {
      const muted = video.muted || video.volume === 0;
      button.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
      unmuteIcon.toggleAttribute('hidden', !muted);
      muteIcon.toggleAttribute('hidden', muted);
    };

    button.addEventListener('click', () => {
      const muted = video.muted || video.volume === 0;
      video.muted = !muted;
      if (muted) video.volume = 1;
      updateControls();
    });

    video.addEventListener('volumechange', updateControls);
    controls.hidden = false;
    updateControls();
  };

  const initializeWithin = (root) => {
    if (root.matches?.('.homepage-hero')) initialize(root);
    root.querySelectorAll('.homepage-hero').forEach(initialize);
  };

  initializeWithin(document);
  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.homepage-hero__video').forEach((video) => video.pause());
  });
})();
